export function numberFormatter(number: number, { locate }: { locate?: string } = {}) {
  return new Intl.NumberFormat(locate).format(number);
}
